import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, TitleCasePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { InteractiveMapModule } from '@smartflip/interactive-map';
import { FormFieldsModule } from '@smartflip/form-fields';
import {
  ComparablesComponent,
  ComparablesFilterActionsComponent,
  FilterChoicesComponent,
  StatusLegendComponent,
} from '@smartflip/feat-comparables';
import { SharedModule } from './../../shared/shared.module';
import { AcquisitionCostsComponent } from './components/acquisition-costs/acquisition-costs.component';
import { CarryingCostsComponent } from './components/carrying-costs/carrying-costs.component';
import { RepairCostsComponent } from './components/repair-costs/repair-costs.component';
import { SellingCostsComponent } from './components/selling-costs/selling-costs.component';
import { OtherCostsComponent } from './components/other-costs/other-costs.component';
import { RepairDetailCostsComponent } from './components/repair-detail-costs/repair-detail-costs.component';
import { PropertyDetailsComponent } from './property-details.component';
import { BudgetPanelComponent } from './components/budget-panel/budget-panel.component';
import { CostDetailsComponent } from './components/cost-details/cost-details.component';
import { GeneralInformationComponent } from './components/general-information/general-information.component';
import { RepairCostRowComponent } from './components/repair-detail-costs/repair-cost-row/repair-cost-row.component';
// import { AddPropertyModalComponent } from './components/add-property-modal/add-property-modal.component';
import { PropertyWorkflowModalComponent } from './components/general-information/property-workflow-modal/property-workflow-modal.component';

@NgModule({
  declarations: [
    // AddPropertyModalComponent,
    PropertyDetailsComponent,
    AcquisitionCostsComponent,
    CarryingCostsComponent,
    RepairCostsComponent,
    SellingCostsComponent,
    OtherCostsComponent,
    RepairDetailCostsComponent,
    BudgetPanelComponent,
    CostDetailsComponent,
    GeneralInformationComponent,
    RepairCostRowComponent,
    PropertyWorkflowModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FormFieldsModule,
    SharedModule,
    InteractiveMapModule,
    StatusLegendComponent,
    ComparablesComponent,
    ComparablesFilterActionsComponent,
    FilterChoicesComponent,
  ],
  exports: [
    PropertyDetailsComponent,
    AcquisitionCostsComponent,
    CarryingCostsComponent,
    RepairCostsComponent,
    SellingCostsComponent,
    OtherCostsComponent,
    RepairDetailCostsComponent,
    BudgetPanelComponent,
    CostDetailsComponent,
    GeneralInformationComponent,
  ],
  providers: [CurrencyPipe, TitleCasePipe],
})
export class PropertyDetailsModule {}
